module.exports = __webpack_public_path__ + "img/javier-trueba-iQPr1XkF5F0-unsplash.82fed254.jpg";